//C:\VUE3\platform\src\constants\statusConstants.js
// statusConstants.js ― 프론트 단일 소스
// C:\VUE3\platform\src\constants\statusConstants.js
export const CONVERSION_STATUS = Object.freeze({
  QUEUED     : 'queued',     // 업로드 직후 큐에 등록된 상태
  PENDING    : 'pending',    // 결과 JSON 파일이 아직 생성되지 않은 초기 대기 상태
  PROCESSING : 'processing', // 서버가 작업을 시작했음을 알리는 중간 상태
  COMPLETED  : 'completed',  // 변환 작업이 성공적으로 완료된 최종 상태
  FAILED     : 'failed',     // 변환 중 예외 발생 시 실패 상태

    // --- 백엔드 예외 핸들러용 추가 상태 ---
  ERROR            : 'error',             // HTTPException/global 예외 핸들러 응답
  VALIDATION_ERROR : 'validation_error',  // RequestValidationError 핸들러 응답
});


export const PARTNER_STATUS_CODE = Object.freeze({
  PENDING: 0, SUBMITTED: 1, SCREENING: 2, APPROVED: 3, REJECTED: 4, COMPLETED: 5, CANCELED: 9,
});
export const PARTNER_STATUS_LABEL = Object.freeze({
  0:'대기',1:'접수됨',2:'검토중',3:'승인됨',4:'반려됨',5:'완료',9:'취소됨'
});
export const PARTNER_STATUS_STYLE = Object.freeze({
  0:{label:'대기',   icon:'bi-pause-circle',
     badgeClass:'bg-secondary-subtle text-secondary-emphasis border border-secondary-subtle'},
  1:{label:'접수됨', icon:'bi-inbox-arrow-down',
     badgeClass:'bg-info-subtle text-info-emphasis border border-info-subtle'},
  2:{label:'검토중', icon:'bi-search',
     badgeClass:'bg-warning-subtle text-warning-emphasis border border-warning-subtle'},
  3:{label:'승인됨', icon:'bi-check2',
     badgeClass:'bg-success-subtle text-success-emphasis border border-success-subtle'},
  4:{label:'반려됨', icon:'bi-x-octagon',
     badgeClass:'bg-danger-subtle text-danger-emphasis border border-danger-subtle'},
  5:{label:'완료',   icon:'bi-flag',
     badgeClass:'bg-primary-subtle text-primary-emphasis border border-primary-subtle'},
  9:{label:'취소됨', icon:'bi-slash-circle',
     badgeClass:'bg-secondary-subtle text-secondary-emphasis border border-secondary-subtle'},
});
export const toPartnerCode = (v) => (typeof v === 'number' ? v : (Number(v) || 1));
export const partnerStatusStyle = (v) => PARTNER_STATUS_STYLE[toPartnerCode(v)];
export const partnerStatusLabel = (v) => PARTNER_STATUS_LABEL[toPartnerCode(v)];
export const partnerAllowEdit   = (v) => toPartnerCode(v) === 1;
export const partnerAllowAttach = (v) => [1,2].includes(toPartnerCode(v));
